import httpClient from './http-clients';

// Fetch all properties
export const fetchAllProperties = async () => {
  const response = await httpClient.get('properties?page=2&limit=100');
  return response.data.data;
};

export const fetchPropertyById = async (id) => {
  const response = await httpClient.get(`properties/${id}`);
  return response.data.data;
};
